"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledMenuItem = exports.MenuItemWrapper = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _LinkButton = _interopRequireDefault(require("../../Buttons/LinkButton"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// External
var MenuItemWrapper = _styledComponents.default.div.withConfig({
  displayName: "SubNavMenustyles__MenuItemWrapper",
  componentId: "h8pyy3-0"
})(["display:inline-block;padding:", " ", ";"], function (props) {
  return props.theme.standardPadding;
}, function (props) {
  return props.theme.mobileGutter;
});

exports.MenuItemWrapper = MenuItemWrapper;
var StyledMenuItem = (0, _styledComponents.default)(_LinkButton.default).withConfig({
  displayName: "SubNavMenustyles__StyledMenuItem",
  componentId: "h8pyy3-1"
})(["font-size:", ";font-weight:", ";position:relative;&:after{border-bottom:3px solid ", ";bottom:-.8rem;content:'';opacity:", ";position:absolute;transition:opacity ", " ease;width:100%;left:0;}&:hover,&:active{text-decoration:none;&:after{border-bottom:3px solid ", ";}}@media only screen and (max-width:", "){font-size:", ";}"], function (props) {
  return props.theme.fontLarge;
}, function (props) {
  return props.theme.secondaryNormal;
}, function (props) {
  return props.theme.c_clickable_link_default;
}, function (props) {
  return props.active ? 1 : 0;
}, function (props) {
  return props.theme.noWaitAnimationDuration;
}, function (props) {
  return props.theme.c_clickable_link_hover;
}, function (props) {
  return props.theme.mediumBreak;
}, function (props) {
  return props.theme.fontMedium;
});
exports.StyledMenuItem = StyledMenuItem;